enum ActionTypes {
  // settings

  SET_IS_FORM_DIRTY = 'SET_IS_FORM_DIRTY',

  // auth
  SILENT_LOGIN = 'auth/SILENT_LOGIN',
  SILENT_LOGIN_SUCCESS = 'auth/SILENT_LOGIN_SUCCESS',
  SILENT_LOGIN_ERROR = 'auth/SILENT_LOGIN_ERROR',

  LOGIN = 'auth/LOGIN',
  LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS',
  LOGIN_ERROR = 'auth/LOGIN_ERROR',

  LOGOUT = 'auth/LOGOUT',
  LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS',
  LOGOUT_ERROR = 'auth/LOGOUT_ERROR',

  LOGIN_EXTERNAL = 'auth/LOGIN_EXTERNAL',
  LOGIN_EXTERNAL_SUCCESS = 'auth/LOGIN_EXTERNAL_SUCCESS',
  LOGIN_EXTERNAL_ERROR = 'auth/LOGIN_EXTERNAL_ERROR',

  SET_NOT_AUTHENTICATED = 'auth/SET_NOT_AUTHENTICATED',

  GET_USER_INFO = 'auth/GET_USER_INFO',
  GET_USER_INFO_SUCCESS = 'auth/GET_USER_INFO_SUCCESS',
  GET_USER_INFO_ERROR = 'auth/GET_USER_INFO_ERROR',

  // global notifications
  SPAWN_GLOBAL_NOTIFICATION = 'global-notification/SPAWN_GLOBAL_NOTIFICATION',
  DISMISS_GLOBAL_NOTIFICATION = 'global-notification/DISMISS_GLOBAL_NOTIFICATION',

  // project
  GET_PROJECTS = 'project/GET_PROJECTS',
  GET_PROJECTS_SUCCESS = 'project/GET_PROJECTS_SUCCESS',
  GET_PROJECTS_ERROR = 'project/GET_PROJECTS_ERROR',

  GET_PROJECT_DETAILS = 'project/GET_PROJECT_DETAILS',
  GET_PROJECT_DETAILS_SUCCESS = 'project/GET_PROJECT_DETAILS_SUCCESS',
  GET_PROJECT_DETAILS_ERROR = 'project/GET_PROJECT_DETAILS_ERROR',

  SET_PROJECT_DETAILS = 'project/SET_PROJECT_DETAILS',

  GET_PROJECT_FILE = 'project/GET_PROJECT_FILE',
  GET_PROJECT_FILE_SUCCESS = 'project/GET_PROJECT_FILE_SUCCESS',
  GET_PROJECT_FILE_ERROR = 'project/GET_PROJECT_FILE_ERROR',

  GET_PROJECT_DOCUMENTS = 'project/GET_PROJECT_DOCUMENTS',
  GET_PROJECT_DOCUMENTS_SUCCESS = 'project/GET_PROJECT_DOCUMENTS_SUCCESS',
  GET_PROJECT_DOCUMENTS_ERROR = 'project/GET_PROJECT_DOCUMENTS_ERROR',

  VALIDATE_SUBCONTRACTOR_ACCOUNT = 'project/VALIDATE_SUBCONTRACTOR_ACCOUNT',
  VALIDATE_SUBCONTRACTOR_ACCOUNT_SUCCESS = 'project/VALIDATE_SUBCONTRACTOR_ACCOUNT_SUCCESS',
  VALIDATE_SUBCONTRACTOR_ACCOUNT_ERROR = 'project/VALIDATE_SUBCONTRACTOR_ACCOUNT_ERROR',

  ADD_SUBCONTRACTOR_TO_PROJECT = 'project/ADD_SUBCONTRACTOR_TO_PROJECT',
  ADD_SUBCONTRACTOR_TO_PROJECT_SUCCESS = 'project/ADD_SUBCONTRACTOR_TO_PROJECT_SUCCESS',
  ADD_SUBCONTRACTOR_TO_PROJECT_ERROR = 'project/ADD_SUBCONTRACTOR_TO_PROJECT_ERROR',

  GET_DELIVERY_ZONES = 'project/GET_DELIVERY_ZONES',
  GET_DELIVERY_ZONES_SUCCESS = 'project/GET_DELIVERY_ZONES_SUCCESS',
  GET_DELIVERY_ZONES_ERROR = 'project/GET_DELIVERY_ZONES_ERROR',

  GET_INTERNAL_USER_PROJECTS = 'project/GET_INTERNAL_USER_PROJECTS',
  GET_INTERNAL_USER_PROJECTS_SUCCESS = 'project/GET_INTERNAL_USER_PROJECTS_SUCCESS',
  GET_INTERNAL_USER_PROJECTS_ERROR = 'project/GET_INTERNAL_USER_PROJECTS_ERROR',

  GET_EXTERNAL_USER_PROJECTS = 'project/GET_EXTERNAL_USER_PROJECTS',
  GET_EXTERNAL_USER_PROJECTS_SUCCESS = 'project/GET_EXTERNAL_USER_PROJECTS_SUCCESS',
  GET_EXTERNAL_USER_PROJECTS_ERROR = 'project/GET_EXTERNAL_USER_PROJECTS_ERROR',

  CHANGE_PROJECT_STATUS = 'project/CHANGE_PROJECT_STATUS',
  CHANGE_PROJECT_STATUS_SUCCESS = 'project/CHANGE_PROJECT_STATUS_SUCCESS',
  CHANGE_PROJECT_STATUS_ERROR = 'project/CHANGE_PROJECT_STATUS_ERROR',

  GET_PROJECT_CONTACTS = 'project/GET_PROJECT_CONTACTS',
  GET_PROJECT_CONTACTS_SUCCESS = 'project/GET_PROJECT_CONTACTS_SUCCESS',
  GET_PROJECT_CONTACTS_ERROR = 'project/GET_PROJECT_CONTACTS_ERROR',

  SET_PROJECTS = 'project/SET_PROJECTS',

  SAVE_PROJECT_DETAILS = 'project/SAVE_PROJECT_DETAILS',
  SAVE_PROJECT_DETAILS_SUCCESS = 'project/SAVE_PROJECT_DETAILS_SUCCESS',
  SAVE_PROJECT_DETAILS_ERROR = 'project/SAVE_PROJECT_DETAILS_ERROR',

  GET_PROJECT_SETTINGS = 'project/GET_PROJECT_SETTINGS',
  GET_PROJECT_SETTINGS_SUCCESS = 'project/GET_PROJECT_SETTINGS_SUCCESS',
  GET_PROJECT_SETTINGS_ERROR = 'project/GET_PROJECT_SETTINGS_ERROR',

  SAVE_PROJECT_SETTINGS = 'project/SAVE_PROJECT_SETTINGS',
  SAVE_PROJECT_SETTINGS_SUCCESS = 'project/SAVE_PROJECT_SETTINGS_SUCCESS',
  SAVE_PROJECT_SETTINGS_ERROR = 'project/SAVE_PROJECT_SETTINGS_ERROR',

  SET_INTERNAL_USER_ROLE = 'project/SET_INTERNAL_USER_ROLE',
  SET_INTERNAL_USER_ROLE_SUCCESS = 'project/SET_INTERNAL_USER_ROLE_SUCCESS',
  SET_INTERNAL_USER_ROLE_ERROR = 'project/SET_INTERNAL_USER_ROLE_ERROR',

  REMOVE_INTERNAL_USER_ROLE = 'projects/REMOVE_INTERNAL_USER_ROLE',
  REMOVE_INTERNAL_USER_ROLE_SUCCESS = 'projects/REMOVE_INTERNAL_USER_ROLE_SUCCESS',
  REMOVE_INTERNAL_USER_ROLE_ERROR = 'projects/REMOVE_INTERNAL_USER_ROLE_ERROR',

  // booking
  EDIT_BOOKING = 'booking/EDIT_BOOKING',
  EDIT_BOOKING_SUCCESS = 'booking/EDIT_BOOKING_SUCCESS',
  EDIT_BOOKING_ERROR = 'booking/EDIT_BOOKING_ERROR',

  GET_BOOKING_LIST = 'booking/GET_BOOKING_LIST',
  GET_BOOKING_LIST_SUCCESS = 'booking/GET_BOOKING_LIST_SUCCESS',
  GET_BOOKING_LIST_ERROR = 'booking/GET_BOOKING_LIST_ERROR',

  GET_BOOKING_PROJECT_SETTINGS_LIST = 'booking/GET_BOOKING_PROJECT_SETTINGS_LIST',
  GET_BOOKING_PROJECT_SETTINGS_LIST_SUCCESS = 'booking/GET_BOOKING_PROJECT_SETTINGS_LIST_SUCCESS',
  GET_BOOKING_PROJECT_SETTINGS_LIST_ERROR = 'booking/GET_BOOKING_PROJECT_SETTINGS_LIST_ERROR',

  GET_BOOKING_PROJECT_SETTINGS = 'booking/GET_BOOKING_PROJECT_SETTINGS',
  GET_BOOKING_PROJECT_SETTINGS_SUCCESS = 'booking/GET_BOOKING_PROJECT_SETTINGS_SUCCESS',
  GET_BOOKING_PROJECT_SETTINGS_ERROR = 'booking/GET_BOOKING_PROJECT_SETTINGS_ERROR',

  BLOCK_BOOKING_SLOT = 'booking/BLOCK_BOOKING_SLOT',
  BLOCK_BOOKING_SLOT_SUCCESS = 'booking/BLOCK_BOOKING_SLOT_SUCCESS',
  BLOCK_BOOKING_SLOT_ERROR = 'booking/BLOCK_BOOKING_SLOT_ERROR',

  REMOVE_BOOKING_SLOTS_PER_DAY = 'booking/REMOVE_BOOKING_SLOTS_PER_DAY',
  REMOVE_BOOKING_SLOTS_PER_DAY_SUCCESS = 'booking/REMOVE_BOOKING_SLOTS_PER_DAY_SUCCESS',
  REMOVE_BOOKING_SLOTS_PER_DAY_ERROR = 'booking/REMOVE_BOOKING_SLOTS_PER_DAY_ERROR',

  UNBLOCK_ALL_DATES = 'booking/UNBLOCK_ALL_DATES',
  UNBLOCK_ALL_DATES_SUCCESS = 'booking/UNBLOCK_ALL_DATES_SUCCESS',
  UNBLOCK_ALL_DATES_ERROR = 'booking/UNBLOCK_ALL_DATES_ERROR',

  UNBLOCK_DATE = 'booking/UNBLOCK_DATE',
  UNBLOCK_DATE_SUCCESS = 'booking/UNBLOCK_DATE_SUCCESS',
  UNBLOCK_DATE_ERROR = 'booking/UNBLOCK_DATE_ERROR',

  CREATE_BOOKING = 'booking/CREATE_BOOKING',
  CREATE_BOOKING_SUCCESS = 'booking/CREATE_BOOKING_SUCCESS',
  CREATE_BOOKING_ERROR = 'booking/CREATE_BOOKING_ERROR',

  CHANGE_SELECTED_DATE = 'booking/CHANGE_SELECTED_DATE',
  CHANGE_SELECTED_PROJECT = 'booking/CHANGE_SELECTED_PROJECT',

  CHANGE_FILTERS = 'booking/CHANGE_FILTERS',
  RESET_FILTERS = 'booking/RESET_FILTERS',

  OPEN_BOOKING_MODAL = 'booking/OPEN_MODAL',
  CLOSE_BOOKING_MODAL = 'booking/CLOSE_MODAL',

  OPEN_BOOKING_DETAILS = 'booking/OPEN_DETAILS',
  CLOSE_BOOKING_DETAILS = 'booking/CLOSE_DETAILS',

  OPEN_EDIT_BOOKINGS_MODAL = 'booking/OPEN_EDIT_BOOKINGS_MODAL',
  CLOSE_EDIT_BOOKINGS_MODAL = 'booking/CLOSE_EDIT_BOOKINGS_MODAL',

  SET_BOOKING_STATUS = 'booking/SET_STATUS',
  SET_BOOKING_STATUS_SUCCESS = 'booking/SET_STATUS_SUCCESS',
  SET_BOOKING_STATUS_ERROR = 'booking/SET_STATUS_ERROR',

  GET_BOOKING_CONFIRMATION = 'booking/GET_BOOKING_CONFIRMATION',
  GET_BOOKING_CONFIRMATION_SUCCESS = 'booking/GET_BOOKING_CONFIRMATION_SUCCESS',
  GET_BOOKING_CONFIRMATION_ERROR = 'booking/GET_BOOKING_CONFIRMATION_ERROR',

  SEND_BOOKING_EMAIL = 'booking/SEND_BOOKING_EMAIL',
  SEND_BOOKING_EMAIL_SUCCESS = 'booking/SEND_BOOKING_EMAIL_SUCCESS',
  SEND_BOOKING_EMAIL_ERROR = 'booking/SEND_BOOKING_EMAIL_ERROR',

  // Barriers
  GET_BARRIERS = 'barriers/GET_BARRIERS',
  GET_BARRIERS_SUCCESS = 'barriers/GET_BARRIERS_SUCCESS',
  GET_BARRIERS_ERROR = 'barriers/GET_BARRIERS_ERROR',

  CREATE_NEW_BARRIER = 'barriers/CREATE_NEW_BARRIER',
  CREATE_NEW_BARRIER_SUCCESS = 'barriers/CREATE_NEW_BARRIER_SUCCESS',
  CREATE_NEW_BARRIER_ERROR = 'barriers/CREATE_NEW_BARRIER_ERROR',

  EDIT_BARRIER_DEVICE = 'barriers/EDIT_BARRIER_DEVICE',
  EDIT_BARRIER_DEVICE_SUCCESS = 'barriers/EDIT_BARRIER_DEVICE_SUCCESS',
  EDIT_BARRIER_DEVICE_ERROR = 'barriers/EDIT_BARRIER_DEVICE_ERROR',

  DELETE_BARRIER_DEVICE = 'barriers/DELETE_BARRIER_DEVICE',
  DELETE_BARRIER_DEVICE_SUCCESS = 'barriers/DELETE_BARRIER_DEVICE_SUCCESS',
  DELETE_BARRIER_DEVICE_ERROR = 'barriers/DELETE_BARRIER_DEVICE_ERROR',

  GET_BARRIER = 'barriers/GET_BARRIER',
  GET_BARRIER_SUCCESS = 'barriers/GET_BARRIER_SUCCESS',
  GET_BARRIER_ERROR = 'barriers/GET_BARRIER_ERROR',

  GET_BARRIER_LOGS = 'barriers/GET_BARRIER_LOGS',
  GET_BARRIER_LOGS_SUCCESS = 'barriers/GET_BARRIER_LOGS_SUCCESS',
  GET_BARRIER_LOGS_ERROR = 'barriers/GET_BARRIER_LOGS_ERROR',

  // Blocked slots
  GET_BLOCKED_SLOT_LIST = 'booking/GET_BLOCKED_SLOT_LIST',
  GET_BLOCKED_SLOT_LIST_SUCCESS = 'booking/GET_BLOCKED_SLOT_LIST_SUCCESS',
  GET_BLOCKED_SLOT_LIST_ERROR = 'booking/GET_BLOCKED_SLOT_LIST_ERROR',

  // subcontractors

  CHANGE_USER_ACCOUNT_STATUS = 'subcontractors/CHANGE_USER_ACCOUNT_STATUS',
  CHANGE_USER_ACCOUNT_STATUS_SUCCESS = 'subcontractors/CHANGE_USER_ACCOUNT_STATUS_SUCCESS',
  CHANGE_USER_ACCOUNT_STATUS_ERROR = 'subcontractors/CHANGE_USER_ACCOUNT_STATUS_ERROR',

  CHANGE_SUBCONTRACTOR_STATUS = 'subcontractors/CHANGE_SUBCONTRACTOR_STATUS',
  CHANGE_SUBCONTRACTOR_STATUS_SUCCESS = 'subcontractors/CHANGE_SUBCONTRACTOR_STATUS_SUCCESS',
  CHANGE_SUBCONTRACTOR_STATUS_ERROR = 'subcontractors/CHANGE_SUBCONTRACTOR_STATUS_ERROR',

  CREATE_SUBCONTRACTOR_ACCOUNT = 'subcontractors/CREATE_SUBCONTRACTOR_ACCOUNT',
  CREATE_SUBCONTRACTOR_ACCOUNT_SUCCESS = 'subcontractors/CREATE_SUBCONTRACTOR_ACCOUNT_SUCCESS',
  CREATE_SUBCONTRACTOR_ACCOUNT_ERROR = 'subcontractors/CREATE_SUBCONTRACTOR_ACCOUNT_ERROR',

  CHANGE_SUBCONTRACTOR_EMAIL = 'subcontractors/CHANGE_SUBCONTRACTOR_EMAIL',
  CHANGE_SUBCONTRACTOR_EMAIL_SUCCESS = 'subcontractors/CHANGE_SUBCONTRACTOR_EMAIL_SUCCESS',
  CHANGE_SUBCONTRACTOR_EMAIL_ERROR = 'subcontractors/CHANGE_SUBCONTRACTOR_EMAIL_ERROR',

  GET_EXTERNAL_USERS_BY_PROJECT_ID = 'subcontractors/GET_EXTERNAL_USERS_BY_PROJECT_ID',
  GET_EXTERNAL_USERS_BY_PROJECT_ID_SUCCESS = 'subcontractors/GET_EXTERNAL_USERS_BY_PROJECT_ID_SUCCESS',
  GET_EXTERNAL_USERS_BY_PROJECT_ID_ERROR = 'subcontractors/GET_EXTERNAL_USERS_BY_PROJECT_ID_ERROR',

  GET_EXTERNAL_USER_CONTACTS = 'subcontractors/GET_EXTERNAL_USER_CONTACTS',
  GET_EXTERNAL_USER_CONTACTS_SUCCESS = 'subcontractors/GET_EXTERNAL_USER_CONTACTS_SUCCESS',
  GET_EXTERNAL_USER_CONTACTS_ERROR = 'subcontractors/GET_EXTERNAL_USER_CONTACTS_ERROR',

  ADD_EXTERNAL_USER_CONTACT = 'subcontractors/ADD_EXTERNAL_USER_CONTACT',
  ADD_EXTERNAL_USER_CONTACT_SUCCESS = 'subcontractors/ADD_EXTERNAL_USER_CONTACT_SUCCESS',
  ADD_EXTERNAL_USER_CONTACT_ERROR = 'subcontractors/ADD_EXTERNAL_USER_CONTACT_ERROR',

  UPDATE_EXTERNAL_USER_CONTACT = 'subcontractors/UPDATE_EXTERNAL_USER_CONTACT',
  UPDATE_EXTERNAL_USER_CONTACT_SUCCESS = 'subcontractors/UPDATE_EXTERNAL_USER_CONTACT_SUCCESS',
  UPDATE_EXTERNAL_USER_CONTACT_ERROR = 'subcontractors/UPDATE_EXTERNAL_USER_CONTACT_ERROR',

  GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS = 'subcontractors/GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS',
  GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_SUCCESS = 'subcontractors/GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_SUCCESS',
  GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_ERROR = 'subcontractors/GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_ERROR',

  SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL = 'subcontractors/SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL',
  SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_SUCCESS = 'subcontractors/SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_SUCCESS',
  SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_ERROR = 'subcontractors/SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_ERROR',

  EDIT_SUBCONTRACTOR_ACCOUNT = 'subcontractors/EDIT_SUBCONTRACTOR_ACCOUNT',
  EDIT_SUBCONTRACTOR_ACCOUNT_SUCCES = 'subcontractors/EDIT_SUBCONTRACTOR_ACCOUNT_SUCCES',
  EDIT_SUBCONTRACTOR_ACCOUNT_ERROR = 'subcontractors/EDIT_SUBCONTRACTOR_ACCOUNT_ERROR',

  SEND_LOGIN_DATA = 'subcontractors/SEND_LOGIN_DATA',
  SEND_LOGIN_DATA_SUCCES = 'subcontractors/SEND_LOGIN_DATA_SUCCES',
  SEND_LOGIN_DATA_ERROR = 'subcontractors/SEND_LOGIN_DATA_ERROR',

  CHANGE_SUBCONTRACTOR_VISIBILITY = 'CHANGE_SUBCONTRACTOR_VISIBILITY',
  CHANGE_SUBCONTRACTOR_VISIBILITY_SUCCESS = 'CHANGE_SUBCONTRACTOR_VISIBILITY_SUCCESS',
  CHANGE_SUBCONTRACTOR_VISIBILITY_ERROR = 'CHANGE_SUBCONTRACTOR_VISIBILITY_ERROR',

  // users
  GET_INTERNAL_USERS = 'users/GET_INTERNAL_USERS',
  GET_INTERNAL_USERS_SUCCESS = 'users/GET_INTERNAL_USERS_SUCCESS',
  GET_INTERNAL_USERS_ERROR = 'users/GET_INTERNAL_USERS_ERROR',

  GET_INTERNAL_USERS_BY_PROJECT_ID = 'users/GET_INTERNAL_USERS_BY_PROJECT_ID',
  GET_INTERNAL_USERS_BY_PROJECT_ID_SUCCESS = 'users/GET_INTERNAL_USERS_BY_PROJECT_ID_SUCCESS',
  GET_INTERNAL_USERS_BY_PROJECT_ID_ERROR = 'users/GET_INTERNAL_USERS_BY_PROJECT_ID_ERROR',

  SET_INTERNAL_USERS = 'users/SET_INTERNAL_USERS',

  GET_EXTERNAL_USERS = 'users/GET_EXTERNAL_USERS',
  GET_EXTERNAL_USERS_SUCCESS = 'users/GET_EXTERNAL_USERS_SUCCESS',
  GET_EXTERNAL_USERS_ERROR = 'users/GET_EXTERNAL_USERS_ERROR',

  GET_EXTERNAL_USER_PROFILE_DETAILS = 'users/GET_EXTERNAL_USER_PROFILE_DETAILS',
  GET_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS = 'users/GET_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS',
  GET_EXTERNAL_USER_PROFILE_DETAILS_ERROR = 'users/GET_EXTERNAL_USER_PROFILE_DETAILS_ERROR',

  UPDATE_EXTERNAL_USER_PROFILE_DETAILS = 'users/UPDATE_EXTERNAL_USER_PROFILE_DETAILS',
  UPDATE_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS = 'users/UPDATE_EXTERNAL_USER_PROFILE_DETAILS_SUCCESS',
  UPDATE_EXTERNAL_USER_PROFILE_DETAILS_ERROR = 'users/UPDATE_EXTERNAL_USER_PROFILE_DETAILS_ERROR',

  UPDATE_INTERNAL_USER_ROLE = 'users/UPDATE_INTERNAL_USER_ROLE',
  UPDATE_INTERNAL_USER_ROLE_SUCCESS = 'users/UPDATE_INTERNAL_USER_ROLE_SUCCESS',
  UPDATE_INTERNAL_USER_ROLE_ERROR = 'users/UPDATE_INTERNAL_USER_ROLE_ERROR',

  // Equipment
  GET_EQUIPMENT_LIST = 'booking/GET_EQUIPMENT_LIST',
  GET_EQUIPMENT_LIST_SUCCESS = 'booking/GET_EQUIPMENT_LIST_SUCCESS',
  GET_EQUIPMENT_LIST_ERROR = 'booking/GET_EQUIPMENT_LIST_ERROR',

  GET_EQUIPMENT = 'booking/GET_EQUIPMENT',
  GET_EQUIPMENT_SUCCESS = 'booking/GET_EQUIPMENT_SUCCESS',
  GET_EQUIPMENT_ERROR = 'booking/GET_EQUIPMENT_ERROR',

  // Delivery zone
  GET_DELIVERY_ZONE_LIST = 'booking/GET_DELIVERY_ZONE_LIST',
  GET_DELIVERY_ZONE_LIST_SUCCESS = 'booking/GET_DELIVERY_ZONE_LIST_SUCCESS',
  GET_DELIVERY_ZONE_LIST_ERROR = 'booking/GET_DELIVERY_ZONE_LIST_ERROR',

  GET_DELIVERY_ZONE = 'booking/GET_DELIVERY_ZONE',
  GET_DELIVERY_ZONE_SUCCESS = 'booking/GET_DELIVERY_ZONE_SUCCESS',
  GET_DELIVERY_ZONE_ERROR = 'booking/GET_DELIVERY_ZONE_ERROR',

  GET_MEANS_OF_TRANSPORT = 'zone/GET_MEANS_OF_TRANSPORT',
  GET_MEANS_OF_TRANSPORT_SUCCESS = 'zone/GET_MEANS_OF_TRANSPORT_SUCCESS',
  GET_MEANS_OF_TRANSPORT_ERROR = 'zone/GET_MEANS_OF_TRANSPORT_ERROR',

  MANAGE_DELIVERY_ZONE = 'zone/MANAGE_DELIVERY_ZONE',
  MANAGE_DELIVERY_ZONE_SUCCESS = 'zone/MANAGE_DELIVERY_ZONE_SUCCESS',
  MANAGE_DELIVERY_ZONE_ERROR = 'zone/MANAGE_DELIVERY_ZONE_ERROR',

  // Notifications
  GET_NOTIFICATIONS = 'notifications/GET_NOTIFICATIONS',
  GET_NOTIFICATIONS_SUCCESS = 'notifications/GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_ERROR = 'notifications/GET_NOTIFICATIONS_ERROR',

  GET_NOTIFICATION_TYPES = 'notifications/GET_NOTIFICATION_TYPES',
  GET_NOTIFICATION_TYPES_SUCCESS = 'notifications/GET_NOTIFICATION_TYPES_SUCCESS',
  GET_NOTIFICATION_TYPES_ERROR = 'notifications/GET_NOTIFICATION_TYPES_ERROR',

  SAVE_NOTIFICATION_TYPE = 'notifications/SAVE_NOTIFICATION_TYPE',
  SAVE_NOTIFICATION_TYPE_SUCCESS = 'notifications/SAVE_NOTIFICATION_TYPE_SUCCESS',
  SAVE_NOTIFICATION_TYPE_ERROR = 'notifications/SAVE_NOTIFICATION_TYPE_ERROR'
}

export default ActionTypes;
